// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"97c0bbe3","170":"dfa43878","387":"c5583e62","440":"785343b4","652":"0e8c3050","826":"a58fde6b","837":"4c269994","942":"2eecdba6","986":"a859d11d","995":"b7cb7752"}[chunkId] + ".chunk.js";
};